export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1696128672709-a995b6dd531a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  mowing: "https://images.unsplash.com/photo-1590820292118-e256c3ac2676?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  gardening: "https://images.unsplash.com/photo-1734079692079-172d8243ebd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  restoration: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/isy6u77n_IMG_4030.jpeg",
  about: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/sk6zjk1g_IMG_4123.JPG",
  grassClose: "https://images.unsplash.com/photo-1533460004989-cef01064af7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  ba1_before: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/uuqad2kd_IMG_4033.jpeg",
  ba1_after: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/u2m25hb4_IMG_4037.jpeg",
  ba2_before: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/zpqohrjb_IMG_4054.jpeg",
  ba2_after: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/k6hovevw_IMG_4069.jpeg",
  ba3_before: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/05oct6zh_IMG_4067.jpeg",
  ba3_after: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/1xkg5dw5_IMG_4064.jpeg",
  ba4_before: "/case4-before.jpg",
  ba4_after: "/case4-after.jpg",
};

export const SERVICES = [
  {
    id: "lawn-mowing",
    num: "01",
    title: "Lawn Mowing & Edge Cutting",
    short: "Level cuts with clean edging on every border, path and driveway.",
    image: IMAGES.mowing,
    points: [
      "Mechanical edge cutting along all borders & paths",
      "Weekly, fortnightly or monthly schedules",
    ],
  },
  {
    id: "gardening",
    num: "02",
    title: "Gardening Maintenance & Waste Removal",
    short: "Hedge shaping, weeding and full green-waste haul-away in one visit.",
    image: "https://customer-assets-0z36b82j.emergentagent.net/job_cba-services-hub/artifacts/waocx4q2_image.png",
    points: [
      "Hedge & shrub trimming to a clean profile",
      "Weeding and gardening maintenance",
      "Complete green-waste collection & eco disposal",
      "Gutter & yard tidy-ups available",
    ],
  },
  {
    id: "restoration",
    num: "03",
    title: "Restoration & Transformation",
    short: "Overgrown and neglected? We reclaim, reshape and rebuild lawns from the ground up.",
    image: IMAGES.restoration,
    points: [
      "Full overgrowth clearance & site reset",
      "Soil prep and levelling",
      "Structural reshaping of beds and borders",
      "Documented before & after transformation",
    ],
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Precision Mowing",
    body: "Every line, edge and border cut with care. Consistent height, clean lines, zero guesswork.",
  },
  {
    num: "02",
    title: "No Mess Guarantee",
    body: "We leave your property cleaner than we found it. Every clipping blown, swept and removed — with all green waste disposed of responsibly, the eco-friendly way.",
  },
  {
    num: "03",
    title: "Complete Revival",
    body: "From forgotten to flawless. We take on the jobs others avoid and hand back a space you're proud of.",
  },
];

export const SUBURBS = [
  "Mango Hill", "North Lakes", "Griffin", "Murrumba Downs",
  "Dakabin", "Kallangur", "Deception Bay", "Rothwell",
  "Newport", "Kippa-Ring",
];

export const CONTACT = {
  phone: "(+61) 410 010 724",
  email: "cbamowing@gmail.com",
  area: "Servicing the greater metro area",
  hours: "Mon – Sat · 7am – 5pm",
};
